import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, List, Spin, Checkbox, Tag } from 'antd';
import { connect } from 'dva';
import BottomActions from './BottomActions';
import styles from '../styles.less';
import ContactPersonFilters from './ContactPersonFilters';

const maxSelectedPeople = 3;

function ContactPerson({ form, onSubmit, goPrevStep, data, countries, dispatch, leadContact, loading, companyName, companyDomain }) {
  const { getFieldDecorator } = form;
  const [isFiltersSet, setIsFiltersSet] = useState(false);
  const peoples = leadContact.peoples;
  const companies = leadContact.companies;

  const handleSubmit = (e) => {
    e.preventDefault();

    form.validateFields((err) => {
      if (!err) {
        onSubmit(form.getFieldsValue());
      }
    });
  };

  const goBack = () => {
    goPrevStep(form.getFieldsValue());
  };

  const createAndValidateRequest = () => {
    const filterValues = form.getFieldsValue();

    const filters = {};
    if (filterValues.filter_company) {
      filters.organization_id = filterValues.filter_company;
    }
    if (filterValues.filter_domain) {
      filters.domain = filterValues.filter_domain;
    }
    if (filterValues.filter_title) {
      filters.title = filterValues.filter_title;
    }
    if (filterValues.filter_keyword) {
      filters.keyword = filterValues.filter_keyword;
    }
    if (filterValues.filter_seniority) {
      filters.seniority = filterValues.filter_seniority;
    }
    if (filterValues.filter_country) {
      filters.location_id = filterValues.filter_country;
    }

    if (!filters.organization_id && !filters.domain) {
      setIsFiltersSet(false);
      return false;
    }
    setIsFiltersSet(true);

    return filters;
  };

  const getPeoples = () => {
    const filters = createAndValidateRequest();
    if (filters) {
      dispatch({
        type: 'leadContact/loadPeoples',
        payload: {
          filters,
        },
      });
    }
  };

  const filterChange = (value, event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    setTimeout(() => {
      getPeoples();
    });
  };

  getFieldDecorator('peoples', { initialValue: data.peoples || [] });
  getFieldDecorator('companySelected', { initialValue: data.companySelected || null });
  getFieldDecorator('defaultCompaniesCount', { initialValue: data.defaultCompaniesCount || null });
  const selectedPeoples = form.getFieldValue('peoples');
  const defaultCompaniesCount = form.getFieldValue('defaultCompaniesCount');

  useEffect(() => {
    if (form.getFieldValue('filter_company')) {
      const company = companies.find(c => c.id === form.getFieldValue('filter_company'));
      form.setFieldsValue({
        companySelected: company,
      });
    } else {
      form.setFieldsValue({
        companySelected: null,
      });
    }
  }, [form.getFieldValue('filter_company')]);

  useEffect(() => {
    if (!('filter_company' in data)) {
      getPeoples();
    } else {
      createAndValidateRequest();
    }
  }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <ContactPersonFilters
        getFieldDecorator={getFieldDecorator}
        data={data}
        countries={countries}
        filterChange={filterChange}
        companyName={companyName}
        companyDomain={companyDomain}
        companies={companies}
        setFieldsValue={form.setFieldsValue}
        getFieldsValue={form.getFieldsValue}
      />
      <Spin
        spinning={
          !!loading.effects['leadContact/loadPeoples']
        }
      >
        <div>
          <span className={styles.peopleSelectedCount}>
            ({selectedPeoples.length}/{maxSelectedPeople})
          </span>
          {selectedPeoples.map(item => (
            <Tag
              color="blue" closable key={item.id} onClose={() => {
                form.setFieldsValue({
                  peoples: selectedPeoples.filter(person => person.id !== item.id),
                });
              }}
            >
              {item.first_name} {item.last_name}
            </Tag>
          ))}
        </div>
        {isFiltersSet ?
          <List
            className={styles.peopleList}
            dataSource={peoples}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta
                  title={`${item.first_name} ${item.last_name}`}
                  description={
                    <React.Fragment>
                      <div className={styles.peopleTitle}>
                        {item.title}
                      </div>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        className={styles.peopleLinkedinUrl}
                        href={item.linkedin_url}
                      >
                        {item.linkedin_url}
                      </a>
                    </React.Fragment>}
                />
                <div className={styles.peopleCheckbox}>
                  <Checkbox
                    checked={!!selectedPeoples.find(person => person.id === item.id)}
                    onChange={() => {
                      const selected = selectedPeoples.find(person => person.id === item.id);
                      if (!selected && selectedPeoples.length < maxSelectedPeople) {
                        form.setFieldsValue({
                          peoples: [...selectedPeoples, item],
                        });
                        return;
                      }
                      form.setFieldsValue({
                        peoples: selectedPeoples.filter(person => person.id !== item.id),
                      });
                    }}
                  />
                </div>
              </List.Item>
            )}
          /> :
          <div className={styles.peopleWarning}>
            <FormattedMessage id={'Component.CreateHubspotTask.Form.Filter.NoFilters'} />
            {!companyDomain && defaultCompaniesCount !== null && defaultCompaniesCount !== 1 &&
              <React.Fragment>
                {
                  defaultCompaniesCount > 1 ?
                    <FormattedMessage
                      id={'Component.CreateHubspotTask.Form.Filter.MoreThanOneCompany'}
                      values={{
                        companyName,
                      }}
                    /> :
                    <FormattedMessage
                      id={'Component.CreateHubspotTask.Form.Filter.ZeroCompany'}
                      values={{
                        companyName,
                      }}
                    />
                }
              </React.Fragment>
            }
          </div>}
      </Spin>

      <BottomActions goBack={goBack} backSuffix={'Close'} nextSuffix={'Next'} />
    </Form>
  );
}

ContactPerson.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func,
  goPrevStep: PropTypes.func,
  countries: PropTypes.array,
  companyName: PropTypes.string,
  companyDomain: PropTypes.string,
};

export default connect((
  {
    loading, leadContact,
  },
) => (
  {
    loading, leadContact,
  }
))(injectIntl(Form.create()(injectIntl(ContactPerson))));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/CreateHubspotTransferModal/components/ContactPerson.js